import { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { MSG } from 'commons/constants';
import { message } from 'antd';

const useB2cNextCode = (params: NextLectureListRepDto) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [codeList, setCodeList] = useState<NextLectureListDto[]>();

  const {  } = useQuery(
    [endpoints.b2c.next_lecture, params],
    () =>
      fetcher.b2c.postNextLectureList(params),
    {
      enabled: (!!params.lecture_gid) && params.lecture_gid > 0,
      onSuccess: (res: CommonListResDto) => {
        switch (res.code) {
          case 200:
            setCodeList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { codeList };
};

export default useB2cNextCode;
